import * as React from 'react';
import styled from '@emotion/styled';
import { Badge, HeadingText20, HeadingText60, Icon, pxToRem } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import { useTranslation } from 'react-i18next';
import { PathwayProviderFragment } from '../documents/fragments.generated';

export interface PathwayPageTitleProps {
    title: string;
    sessionCount: number;
    duration: number;
    provider: PathwayProviderFragment['provider'] | undefined;
}

export const PathwayCreatedHeader: React.FC<PathwayPageTitleProps> = ({
    title,
    sessionCount,
    duration,
    provider,
}) => {
    const { t } = useTranslation();

    if (!provider) {
        return null;
    }

    return (
        <>
            <Badge variant="success" title={t('pathways:your_pathway')} size="medium" />
            <HeadingText60 marginTop={20} centered>
                {t('pathways:components.pathway_created_header.title', {
                    pathway: title,
                    provider: `${provider.firstName} ${provider.lastName}`,
                })}
            </HeadingText60>
            <CenteredContent>
                <CenteredContent as="span">
                    <Icon name="calendar" height={12} />
                    <HeadingText20 marginLeft={3}>
                        {t('pathways:components.pathway_created_header.sessions', { sessionCount })}
                    </HeadingText20>
                </CenteredContent>
                <Dot />
                {duration > 0 && (
                    <CenteredContent as="span">
                        <Icon name="clock" height={12} />
                        <HeadingText20 marginLeft={3}>
                            {t('pathways:components.pathway_created_header.total_hours', {
                                duration,
                            })}
                        </HeadingText20>
                    </CenteredContent>
                )}
            </CenteredContent>
        </>
    );
};

const CenteredContent = styled.div({
    display: 'flex',
    alignItems: 'center',
});

const Dot = styled.span({
    height: pxToRem(5),
    width: pxToRem(5),
    backgroundColor: colors.black,
    borderRadius: '50%',
    display: 'inline-block',
    margin: pxToRem(7),
});
